import { supabase } from '@/lib/supabase'
import type { Tables } from '@/types/database.types'

export type BudgetItem = Tables<'budget_items'>
export type BudgetCategory = 'transport' | 'accommodation' | 'food' | 'activities'

export interface NewBudgetItemInput {
  tripId: string
  label: string
  category?: BudgetCategory
  plannedAmount: number
  actualAmount: number
}

export async function listBudgetItems(tripId: string): Promise<BudgetItem[]> {
  const { data, error } = await supabase
    .from('budget_items')
    .select('*')
    .eq('trip_id', tripId)
    .order('created_at')
  if (error) throw error
  return data
}

export async function createBudgetItem(input: NewBudgetItemInput): Promise<BudgetItem> {
  const { data, error } = await supabase
    .from('budget_items')
    .insert({
      trip_id: input.tripId,
      label: input.label,
      category: input.category,
      planned_amount: input.plannedAmount,
      actual_amount: input.actualAmount,
    })
    .select()
    .single()
  if (error) throw error
  return data
}

export interface BudgetItemPatch {
  label: string
  category?: BudgetCategory
  plannedAmount: number
  actualAmount: number
}

export async function updateBudgetItem(
  itemId: string,
  patch: BudgetItemPatch,
): Promise<BudgetItem> {
  const { data, error } = await supabase
    .from('budget_items')
    .update({
      label: patch.label,
      category: patch.category ?? null,
      planned_amount: patch.plannedAmount,
      actual_amount: patch.actualAmount,
    })
    .eq('id', itemId)
    .select()
    .single()
  if (error) throw error
  return data
}

export async function deleteBudgetItem(itemId: string): Promise<void> {
  const { error } = await supabase.from('budget_items').delete().eq('id', itemId)
  if (error) throw error
}
